import {
  takeLatest,
  call,
  put,
  all,
  fork,
  join,
} from 'redux-saga/effects';
import {
  types,
  setUserRoles,
  setServerProperties,
  clearToken,
  setAppError,
} from './actions';
import { getRolesEnum } from '@services/authenticationService';
import { getServerProperties as fetchServerProperties } from '@services/propertiesService';
import { closePopUp } from "@containers/App/containers/PopUp/actions";
import { tryingToExitExerciseAction } from '@containers/User/containers/CourseRouter/containers/Practice/actions';
import { endActivityLesson } from '@containers/User/containers/CourseRouter/containers/Lesson/actions';
import { cognitoLogOut } from '@services/cognitoUserService';
import { notifyTimeTrackerLogout } from '@shared/TimeTracker/events';

const useFixtures = process.env.USE_FIXTURES;

function* getuserRoles() {
  try {
    const res = yield fork(getRolesEnum);
    const rolesEnum = yield join(res);
    if (rolesEnum) {
      yield put(setUserRoles(rolesEnum));
    } else {
      yield put(setUserRoles({}));
    }
  } catch (error) {
    yield put(setUserRoles({}));
    yield put(setAppError(error.message))
  }
}

function* getServerProperties() {
  try {
    const properties = yield call(fetchServerProperties);
    yield put(setServerProperties(properties));
  } catch (error) {
    yield put(setServerProperties([]));
    yield put(setAppError(error.message))
  }
}

function* closePopUps() {
  yield put(closePopUp())
}
function* stopRecordVideoAndSound(action) {
  try {
    const data = action?.data;
    if (!data) {
      return;
    }

    const {
      exerciseInProgress,
      lessonInProgress,
      activityLessonId,
    } = data;
    if (exerciseInProgress) {
      yield put(tryingToExitExerciseAction(true));
    }
    if (activityLessonId && lessonInProgress) {
      yield put(endActivityLesson(activityLessonId, true));
    }
  } catch (error) {
    yield put(setAppError(error.message))
  }
}

function* safeCognitoLogOut() {
  try {
    yield call(cognitoLogOut);
  } catch (error) {
    console.error('Error during Cognito logout:', error);
  }
}

function* logoutSaga(action) {
  yield all([
    call(notifyTimeTrackerLogout),
    call(closePopUps),
    call(stopRecordVideoAndSound, action),
    call(safeCognitoLogOut),
  ]);

  // Always clear local auth state last.
  const preserveCognitoNewPasswordChallenge = Boolean(
    action?.data?.preserveCognitoNewPasswordChallenge,
  );
  yield put(clearToken({ preserveCognitoNewPasswordChallenge }));
}
function* watchGetuserRoles() {
  yield takeLatest(types.GET_USER_ROLES, getuserRoles);
}
function* watchGetServerProperties() {
  yield takeLatest(types.GET_SERVER_PROPERTIES, getServerProperties);
}
function* watchLogOut() {
  yield takeLatest(types.LOG_OUT, logoutSaga);
}

export default function* getPendingDashboardDataAppSaga() {
  yield all([
    fork(watchGetuserRoles),
    fork(watchGetServerProperties),
    fork(watchLogOut),
  ]);
}
